import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { Get, JENIS_DUSUN, Post } from '../../function/Koneksi';
import { generateAlamat } from '../../function/Format';

const ModalSuratTidakMenikah = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmDex = {
		uuid: '',
		id_jenis: "",
		nik: "",
		nama_pemohon: "",
		tempat_lahir: "",
		tanggal_lahir: "",
		jenis_kelamin: "",
		status_perkawinan: null,
		pekerjaan: "",
		agama: "",
		alamat: "",
		kewarganegaraan: "Indonesia",
		pendidikan_terakhir: "",
		tujuan_pembuatan: "",
		nomor_surat_akta: "",
		nama_saksi: "",
		hubungan_saksi: null,
		tanggal_surat_akta: new Date(),
		status_ttd: ''
	}

	const initFormData = {
		frmNik: optionData.frmNik,
		tmplistPenduduk: optionData.tmplistPenduduk,
		nikStat: null,
		frmShdk: optionData.frmShdk,
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		console.log(data);

		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			nikStat: optionData.nikStat,
			frmShdk: optionData.frmShdk,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false) {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

    const changeStatusPerkawinan = (e) => {
        if (e) {
            setDt({
                ...dt,
                status_perkawinan: {value: e.label, label: e.label},
            })   
        } else {
            setDt({
                ...dt,
                status_perkawinan: null,
            }) 
        }
      }

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const gantiTgl = (date, fld) => {
		switch (fld) {
			case "tanggal_surat_akta":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD HH:mm');
					setDt({
						...dt,
						tanggal_surat_akta: new Date(tgl),
					})
				}
				break;
			default:
				// no default
				break;
		}
	};

	const getPenduduk = (e, sel, jns) => {
		if (e) {
			// this.changeSelectValue(e, sel);
            if (kioskMode) {
                props.setLoadingPreview(true)
            }
            else{
                setAlert({
                    loadingPreview: true
                })
            }

            Get("penduduk/find", e.value, data => {
                if(data.results){
                    const alamat = generateAlamat(data.results);
                    let alamat_kk = "";
              
                    if(data.results.data_kk){
                        alamat_kk = data.results.data_kk.alamat
                    }

                    // pelapor
                    setFormData({
                        ...formData,
                        nikStat: e,
                        status: {
                            ...formData.status,
                            dataPenduduk: "block",
                        },
                    })

                    setDt({
                        ...dt,
                        nik: data.results.id,
                        nik_pelapor: data.results.id,
                        kk: data.results.id_kk,
                        nama_pemohon: data.results.nama,
                        tempat_lahir: data.results.tempat_lahir,
                        tanggal_lahir: new Date(
                            data.results.tanggal_lahir
                        ),
                        pekerjaan: data.results.data_pekerjaan.nama,
                        pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                        agama: data.results.data_agama.nama,
                        status_perkawinan: data.results.status_perkawinan,
                        jenis_kelamin: data.results.jk,
                        alamat: alamat,
                        alamat_kk: alamat_kk,
                        kewarganegaraan: 'Indonesia',
                    })   

                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }     
                }
                else{
                    if (kioskMode) {
                        props.setLoadingPreview(true)
                    }
                    else{
                        setAlert({
                            loadingPreview: true
                        })
                    }
                }
            })
		} else {
			// setDt(frmDex)
			setDt({
				...dt,
				nik: '',
				nik_pelapor: '',
				kk: '',
				nama_pemohon: '',
				tempat_lahir: '',
				tanggal_lahir: '',
				pekerjaan: '',
				pendidikan_terakhir: '',
				agama: '',
				status_perkawinan: '',
				jenis_kelamin: '',
				alamat: '',
				alamat_kk: '',
				kewarganegaraan: '',
			})
			setFormData({
				...formData,
				nikStat: null,
				status: {
					...formData.status,
					dataPenduduk: "none",
				},
			})
		}
	};

	const simpan = (e) => {
		e.preventDefault();

        if (kioskMode){
            props.setLoadingPreview(true)
        }
        else{
            setAlert({
                loadingPreview: true
            })
        }

		let validasiPelapor = formData.nikStat;

		if (validasiPelapor && dt.hubungan_saksi && dt.status_perkawinan) {
			if (kioskMode) {
				props.setLoadingPreview(true)
			}
	
			let bodyRaw = {
				...dt,
				tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir), 'yyyy-mm-dd'),
				tanggal_surat_akta: dateFormat(new Date(dt.tanggal_surat_akta), 'yyyy-mm-dd'),
				tujuan_pembuatan: "Surat Pernyataan Tidak Menikah",
				hubungan_saksi: dt.hubungan_saksi.label,
                status_perkawinan: dt.status_perkawinan.value,
			}
			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}
			Post(
				"surat-keterangan/grup/" + metode + "/tidak-menikah",
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					// Kalau mode kiosk
					if (kioskMode) {
                        if (res.status === resstat) {
                            let dataAntrian = {
                                nama: props.data.results.nama,
                                nik: props.data.results.id,
                                keterangan: '',
                                uuid_surat:res.data.results.uuid_surat,
                                kode_surat:res.data.results.kode_surat,
                            };
    
                            // Set Data Surat
                            props.getDataSurat(res.data.results);

							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
									
									props.setLoadingPreview(false)

									if (res2.code === 201) {
										props.getAntrian('Surat Pernyataan Tidak Menikah', 'berhasil', false, dataAntrian);
									}
									else {
										props.getAntrian('Surat Pernyataan Tidak Menikah', 'gagal');
									}
								});
							}.bind(this),1000)
                        }
                        else{
							props.setLoadingPreview(false)
                          	props.getAntrian('Surat Pernyataan Tidak Menikah', 'gagal');
                        }
					} else { // Kalau bukan kiosk
						if (res.status === resstat) {
							const alertData = {
                                get_data_surat:{
                                    uuid_surat:res.data.results.uuid_surat,
                                    kode_surat:res.data.results.kode_surat,
                                },
                                status:{
                                    frmPreviewDraft: true,
                                    jenis_form: psn,
                                }
                                // show: true,
                                // basicType: "success",
                                // basicTitle: "Data Surat Keterangan Kematian V2",
                                // pesanAlert: "Berhasil " + psn + " Data",
                                // successAlert: true
                            };
							setAlert({
							  	loadingPreview: false
							})
                            setAlert(alertData);
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Pernyataan Tidak Menikah",
								pesanAlert: "Gagal " + psn + " Data"
							}
							setAlert({
							  	loadingPreview: false
							})
							setAlert(alertData)
						}

						// Refresh list
						setStatusRefresh(true)
					}
				}
			);
		} else {
			if (kioskMode){
				props.getAntrian('Surat Pernyataan Tidak Menikah', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
		}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan} >
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
					<div className="modal-header">
						<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Pernyataan Tidak Menikah</h5>
					</div>
					<div className="modal-body">
						<p>
							Data identitas akan terisi secara otomatis saat NIK dipilih.
							Jika ada ketidak sesuaian data, silakan ubah di data master
							penduduk.
						</p>
						<input
							className="form-control"
							id="uuid"
							type="hidden"
							placeholder=""
							defaultValue={dt.uuid}
						/>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								NIK
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK">
									<Select
										inputId="nik"
										classNamePrefix="select"
										onChange={e => {
											getPenduduk(e, "nik", "pelapor");
										}}
										defaultValue={formData.nikStat}
										value={formData.nikStat}
										name="nik"
										options={formData.frmNik}
										placeholder="Pilih NIK"
										onInputChange={e => handleInputChangeNIK(e, 'nik')}
										isClearable
									/>
								</div>
							</Col>
						</FormGroup>
						<div style={{ display: formData.status.dataPenduduk }}>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pemohon
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama_pemohon"
										type="text"
										placeholder="Nama Pemohon"
										value={dt.nama_pemohon}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tempat_lahir"
										type="text"
										placeholder="Tempat Lahir"
										value={dt.tempat_lahir}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tanggal_lahir"
										type="text"
										placeholder="Tanggal Lahir"
										value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Alamat
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat_kk"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat_kk}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Wilayah
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                    <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                </Col>
                                </FormGroup>
						</div>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="status_perkawinan"
                            >
                                Status Perkawinan
                            </Label>
                            <Col sm="9">
                                <div data-testid="selectKawin">
                                    <Select
                                        inputId="status_perkawinan"
                                        name="status_perkawinan"
                                        id="status_perkawinan"
                                        classNamePrefix="select"
                                        onChange={e => {
											changeStatusPerkawinan(e);
										}}
                                        value={dt.status_perkawinan}
                                        options={[
                                        {value: 'Cerai Hidup', label: 'Cerai Hidup'},
                                        {value: 'Cerai Mati', label: 'Cerai Mati'},
                                        ]}
                                        placeholder="Pilih Status Perkawinan"
                                        isClearable
                                    />
                                </div>
                            </Col>
                        </FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Nomor Surat Akta Cerai
							</Label>
							<Col sm="9">
								<input
									data-testid="nomor surat akta"
									name="nomor_surat_akta"
									className="form-control"
									id="nomor_surat_akta"
									type="text"
									placeholder="Nomor Surat Akta "
									defaultValue={dt.nomor_surat_akta}
									onChange={e => changeInputText(e, "nomor_surat_akta")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="tanggal_surat_akta"
							>
								Tanggal Surat Akta Cerai
							</Label>
							<Col sm="9">
								<Datetime
									inputProps={{ "data-testid": "tanggal_surat_akta", placeholder: 'Tanggal Surat Akta', required: true }}
									data-testid="tanggal_surat_akta"
									// name="rencana_berangkat"
									inputId="tanggal_surat_akta"
									name="tanggal_surat_akta"
									id="tanggal_surat_akta"
									locale="id-ID"
									input={true}
									closeOnTab={true}
									timeFormat={false}
									dateFormat="DD/MM/yyyy"
									closeOnSelect={true}
									initialValue={dt.tanggal_surat_akta}
									value={dt.tanggal_surat_akta}
									onChange={e => {
										gantiTgl(e, "tanggal_surat_akta");
									}}
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Nama Saksi
							</Label>
							<Col sm="9">
								<input
									data-testid="nama saksi"
									name="nama_saksi"
									className="form-control"
									id="nama_saksi"
									type="text"
									placeholder="Nama Saksi"
									defaultValue={dt.nama_saksi}
									onChange={e => changeInputText(e, "nama_saksi")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Hubungan Saksi
							</Label>
							<Col sm="9">
								<Select
									inputId="hubungan_saksi1"
									classNamePrefix="select"
									onChange={e => {
										setDt({
											...dt,
											hubungan_saksi: e
										})
									}}
									defaultValue={dt.hubungan_saksi}
									value={dt.hubungan_saksi}
									name="hubungan_saksi"
									options={formData.frmShdk}
									placeholder="Pilih Hubungan Saksi"
								/>
								{/* <input
									data-testid="hubungan saksi"
									name="hubungan_saksi"
									className="form-control"
									id="hubungan_saksi"
									type="text"
									placeholder="Hubungan Saksi"
									defaultValue={dt.hubungan_saksi}
									onChange={e => changeInputText(e, "hubungan_saksi")}
									required
								/> */}
							</Col>
						</FormGroup>
						{/* <FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tujuan pembuatan
							</Label>
							<Col sm="9">
								<input
									data-testid="tujuan pembuatan"
									name="tujuan_pembuatan"
									className="form-control"
									id="tujuan_pembuatan"
									type="text"
									minLength={3}
									placeholder="Contoh : Pengurusan beasiswa"
									defaultValue={dt.tujuan_pembuatan}
									value={dt.tujuan_pembuatan}
									onChange={e => changeInputText(e, "tujuan_pembuatan")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tempat Tinggal Sekarang
							</Label>
							<Col sm="9">
								<input
									data-testid="lokasi"
									name="lokasi"
									className="form-control"
									id="lokasi"
									type="text"
									placeholder="Contoh : Menumpang di rumah orang tua"
									defaultValue={dt.lokasi}
									value={dt.lokasi}
									onChange={e => changeInputText(e, "lokasi")}
									required
								/>
							</Col>
						</FormGroup> */}
					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-warning"
							onClick={() => {
								// Tutup modal
								setFormData({
									...formData,
									status: {
										...formData.status,
										form: false
									}
								})
								setIsOpen(false)
							}}
						>
							Tutup
						</button>
						<button
							data-testid="btnSubmitCreate"
							type="submit"
							className="btn btn-primary-custom"
						// disabled={formData.status && formData.status.btnForm}
						>
							Simpan
						</button>
					</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalSuratTidakMenikah;
